import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';

import { MIN_TASK_WIDTH_PX } from '../models/timeline';
import { EditPlacing, EditTarget } from './timeline-edit.service';
import { TimelineGeometry, xOfDate } from './timeline-geometry';

/**
 * The places of one route a stop can land, drawn in its row in the same coordinates as its blocks:
 * a line for each gap, an outline over each stop it can merge into, a tail at the route's end.
 */
@Component({
  selector: 'app-timeline-edit-targets',
  imports: [DatePipe, TranslatePipe],
  templateUrl: './timeline-edit-targets.component.html',
  styleUrl: './timeline-edit-targets.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineEditTargetsComponent {
  readonly targets = input.required<EditTarget[]>();
  readonly hot = input<EditTarget | null>(null);
  readonly geometry = input.required<TimelineGeometry>();
  /** The stop or job being placed, carried beside the pointer while it is over this row. */
  readonly carried = input<Pick<EditPlacing, 'kind' | 'name' | 'site' | 'quantity'> | null>(
    null
  );

  protected readonly ICONS = ICONS;

  protected readonly shown = computed(() => {
    const geometry = this.geometry();
    const hot = this.hot();
    return this.targets().map((target) => {
      const left = target.stop ? xOfDate(geometry, target.stop.start) : 0;
      return {
        target,
        x: xOfDate(geometry, target.at),
        left,
        width: target.stop
          ? Math.max(MIN_TASK_WIDTH_PX, xOfDate(geometry, target.stop.end) - left)
          : 0,
        hot: target === hot
      };
    });
  });
}
